<div class="content mb-0">
  <h4 class="text-primary">Routinen hinzufügen</h4>
  <p class="font-weight-bolder">
    Klick auf die Kategorien und füge weitere Routinen zu deiner persönlichen Routine hinzu.
  </p>

  <div class="list-group list-custom-small list-icon-0">
    <div class="no-effect collapsed" onclick="new bootstrap.Collapse( '#collapse-daily-morning', { toggle: true } )" aria-expanded="false">
      <span class="font-14 text-uppercase text-black">Morgenroutine</span>
      <i class="fa fa-angle-down"></i>
    </div>
  </div>
  <div class="collapse" id="collapse-daily-morning">
    <div class="list-group list-custom-small" style="line-height: 42px!important;">
      <% for ( let ri = 0; ri < morningRoutines.length; ri++ ) {  %>
       <% if ( false === routinePlan.containsRoutine( morningRoutines[ ri ].id ) ) { %>
          <div class="shadow-l rounded-2 mb-3">
            <div class="align-self-center" style="min-width: 40px; display: inline-block">
              <% if ( morningRoutines[ ri ].icon ) {  %>
                <img src="/assets/icons/routines/<%= morningRoutines[ ri ].icon %>" style="max-width: 18px; margin-left: 11px" />
              <% }  %>
            </div>
            <span class="font-weight-bolder"><%= morningRoutines[ ri ].name %></span>
            <div data-type="btnAdd"
                 data-routine-id="<%= morningRoutines[ ri ].id %>"
                 data-goal="<%= morningRoutines[ ri ].goal %>"
                 data-category-id="<%= morningRoutines[ ri ].categoryId %>"
                 data-name="<%= morningRoutines[ ri ].name %>"
                 data-icon="<%= morningRoutines[ ri ].icon %>"
                 data-weekly-frequence="<%= morningRoutines[ ri ].weeklyFrequence %>"
                 style="display: inline-block; float: right"
                 class="clickable">
              <i class="fas fa-plus-circle" style="font-size: 18px; margin-right: 11px; line-height: 42px"></i>
            </div>
          </div>
        <% }  %>
      <% }  %>
    </div>
  </div>

  <div class="list-group list-custom-small list-icon-0">
    <div class="no-effect collapsed" onclick="new bootstrap.Collapse( '#collapse-daily-midday', { toggle: true } )" aria-expanded="false">
      <span class="font-14 text-uppercase text-black">Mittagsroutine</span>
      <i class="fa fa-angle-down"></i>
    </div>
  </div>
  <div class="collapse" id="collapse-daily-midday" style="">
    <div class="list-group list-custom-small">
      <% for ( let ri = 0; ri < middayRoutines.length; ri++ ) {  %>
        <% if ( false === routinePlan.containsRoutine( middayRoutines[ ri ].id ) ) { %>
        <div class="shadow-l rounded-2 mb-3">
          <div class="align-self-center" style="min-width: 40px; display: inline-block">
            <% if ( middayRoutines[ ri ].icon ) {  %>
              <img src="/assets/icons/routines/<%= middayRoutines[ ri ].icon %>" style="max-width: 18px; margin-left: 11px" />
            <% }  %>
          </div>
          <span class="font-weight-bolder"><%= middayRoutines[ ri ].name %></span>
          <div data-type="btnAdd"
               data-routine-id="<%= middayRoutines[ ri ].id %>"
               data-goal="<%= middayRoutines[ ri ].goal %>"
               data-category-id="<%= middayRoutines[ ri ].categoryId %>"
               data-name="<%= middayRoutines[ ri ].name %>"
               data-icon="<%= middayRoutines[ ri ].icon %>"
               data-weekly-frequence="<%= middayRoutines[ ri ].weeklyFrequence %>"
               style="display: inline-block; float: right"
               class="clickable">
            <i class="fas fa-plus-circle" style="float:font-size: 18px; margin-right: 11px; line-height: 42px"></i>
          </div>
        </div>
        <% }  %>
      <% }  %>
    </div>
  </div>

  <div class="list-group list-custom-small list-icon-0">
    <div class="no-effect collapsed" onclick="new bootstrap.Collapse( '#collapse-daily-evening', { toggle: true } )" aria-expanded="false">
      <span class="font-14 text-uppercase text-black">Abendroutine</span>
      <i class="fa fa-angle-down"></i>
    </div>
  </div>
  <div class="collapse" id="collapse-daily-evening">
    <div class="list-group list-custom-small">
      <% for ( let ri = 0; ri < eveningRoutines.length; ri++ ) {  %>
        <% if ( false === routinePlan.containsRoutine( eveningRoutines[ ri ].id ) ) { %>
          <div class="shadow-l rounded-2 mb-3">
            <div class="align-self-center" style="min-width: 40px; display: inline-block">
              <% if ( eveningRoutines[ ri ].icon ) {  %>
              <img src="/assets/icons/routines/<%= eveningRoutines[ ri ].icon %>" style="max-width: 18px; margin-left: 11px" />
              <% }  %>
            </div>
            <span class="font-weight-bolder"><%= eveningRoutines[ ri ].name %></span>
            <div data-type="btnAdd"
                 data-routine-id="<%= eveningRoutines[ ri ].id %>"
                 data-goal="<%= eveningRoutines[ ri ].goal %>"
                 data-category-id="<%= eveningRoutines[ ri ].categoryId %>"
                 data-name="<%= eveningRoutines[ ri ].name %>"
                 data-icon="<%= eveningRoutines[ ri ].icon %>"
                 data-weekly-frequence="<%= eveningRoutines[ ri ].weeklyFrequence %>"
                 style="display: inline-block; float: right"
                 class="clickable">
              <i class="fas fa-plus-circle" style="font-size: 18px; margin-right: 11px; line-height: 42px"></i>
            </div>
          </div>
        <% }  %>
      <% }  %>
    </div>
  </div>

  <div class="list-group list-custom-small list-icon-0">
    <div class="no-effect collapsed" onclick="new bootstrap.Collapse( '#collapse-weekly-goal-sport', { toggle: true } )" aria-expanded="false">
      <span class="font-14 text-uppercase text-black">Wochenziele: Sport</span>
      <i class="fa fa-angle-down"></i>
    </div>
  </div>
  <div class="collapse" id="collapse-weekly-goal-sport">
    <div class="list-group list-custom-small">
      <% for ( let ri = 0; ri < weeklySportRoutines.length; ri++ ) {  %>
        <% if ( false === routinePlan.containsRoutine( weeklySportRoutines[ ri ].id ) ) { %>
          <div class="shadow-l rounded-2 mb-3">
            <div class="align-self-center" style="min-width: 40px; display: inline-block">
              <% if ( weeklySportRoutines[ ri ].icon ) {  %>
                <img src="/assets/icons/routines/<%= weeklySportRoutines[ ri ].icon %>" style="max-width: 18px; margin-left: 11px" />
              <% }  %>
            </div>
            <span class="font-weight-bolder">
              <select data-type="weekly-frequence-selector"
                      data-routine-id="<%= weeklySportRoutines[ ri ].id %>"
                      style="width:40px"><option>1</option><option>2</option><option>3</option><option>4</option><option>5</option><option>6</option><option>7</option></select><%= weeklySportRoutines[ ri ].name.replace( '__WT__', '' ) %>
            </span>
            <div data-type="btnAdd"
                 data-routine-id="<%= weeklySportRoutines[ ri ].id %>"
                 data-goal="<%= weeklySportRoutines[ ri ].goal %>"
                 data-category-id="<%= weeklySportRoutines[ ri ].categoryId %>"
                 data-name="<%= weeklySportRoutines[ ri ].name %>"
                 data-icon="<%= weeklySportRoutines[ ri ].icon %>"
                 data-weekly-frequence="1"
                 style="display: inline-block; float: right"
                 class="clickable">
              <i class="fas fa-plus-circle" style="float:right; font-size: 18px; margin-right: 11px; line-height: 42px"></i>
            </div>
          </div>
        <% }  %>
      <% }  %>
    </div>
  </div>

  <div class="list-group list-custom-small list-icon-0">
    <div class="no-effect collapsed" onclick="new bootstrap.Collapse( '#collapse-weekly-goal-consume', { toggle: true } )" aria-expanded="false">
      <span class="font-14 text-uppercase text-black">Wochenziele: Konsum</span>
      <i class="fa fa-angle-down"></i>
    </div>
  </div>
  <div class="collapse" id="collapse-weekly-goal-consume">
    <div class="list-group list-custom-small">
      <% for ( let ri = 0; ri < weeklyConsumeRoutines.length; ri++ ) {  %>
        <% if ( false === routinePlan.containsRoutine( weeklyConsumeRoutines[ ri ].id ) ) { %>
          <div class="shadow-l rounded-2 mb-3">
            <div class="align-self-center" style="min-width: 40px; display: inline-block">
              <% if ( weeklyConsumeRoutines[ ri ].icon ) {  %>
                <img src="/assets/icons/routines/<%= weeklyConsumeRoutines[ ri ].icon %>" style="max-width: 18px; margin-left: 11px" />
              <% }  %>
            </div>
            <span class="font-weight-bolder">
              <select data-type="weekly-frequence-selector"
                      data-routine-id="<%= weeklyConsumeRoutines[ ri ].id %>"
                      style="width:40px"><option>1</option><option>2</option><option>3</option><option>4</option><option>5</option><option>6</option><option>7</option></select><%= weeklyConsumeRoutines[ ri ].name.replace( '__WT__', '' ) %>
            </span>
            <div data-type="btnAdd"
                 data-routine-id="<%= weeklyConsumeRoutines[ ri ].id %>"
                 data-goal="<%= weeklyConsumeRoutines[ ri ].goal %>"
                 data-category-id="<%= weeklyConsumeRoutines[ ri ].categoryId %>"
                 data-name="<%= weeklyConsumeRoutines[ ri ].name %>"
                 data-icon="<%= weeklyConsumeRoutines[ ri ].icon %>"
                 data-weekly-frequence="1"
                 style="display: inline-block; float: right"
                 class="clickable">
              <i class="fas fa-plus-circle" style="font-size: 18px; margin-right: 11px; line-height: 42px"></i>
            </div>
          </div>
        <% }  %>
      <% }  %>
    </div>
  </div>

  <div class="list-group list-custom-small list-icon-0">
    <div class="no-effect collapsed" onclick="new bootstrap.Collapse( '#collapse-weekly-goal-spirit', { toggle: true } )" aria-expanded="false">
      <span class="font-14 text-uppercase text-black">Wochenziele: Geist & Körper</span>
      <i class="fa fa-angle-down"></i>
    </div>
  </div>
  <div class="collapse" id="collapse-weekly-goal-spirit">
    <div class="list-group list-custom-small">
      <% for ( let ri = 0; ri < weeklySpiritRoutines.length; ri++ ) {  %>
        <% if ( false === routinePlan.containsRoutine( weeklySpiritRoutines[ ri ].id ) ) { %>
          <div class="shadow-l rounded-2 mb-3">
            <div class="align-self-center" style="min-width: 40px; display: inline-block">
              <% if ( weeklySpiritRoutines[ ri ].icon ) {  %>
                <img src="/assets/icons/routines/<%= weeklySpiritRoutines[ ri ].icon %>" style="max-width: 18px; margin-left: 11px" />
              <% }  %>
            </div>
            <span class="font-weight-bolder">
              <select data-type="weekly-frequence-selector"
                      data-routine-id="<%= weeklySpiritRoutines[ ri ].id %>"
                      style="width:40px"><option>1</option><option>2</option><option>3</option><option>4</option><option>5</option><option>6</option><option>7</option></select><%= weeklySpiritRoutines[ ri ].name.replace( '__WT__', '' ) %>
            </span>
            <div data-type="btnAdd"
                 data-routine-id="<%= weeklySpiritRoutines[ ri ].id %>"
                 data-goal="<%= weeklySpiritRoutines[ ri ].goal %>"
                 data-category-id="<%= weeklySpiritRoutines[ ri ].categoryId %>"
                 data-name="<%= weeklySpiritRoutines[ ri ].name %>"
                 data-icon="<%= weeklySpiritRoutines[ ri ].icon %>"
                 data-weekly-frequence="1"
                 style="display: inline-block; float: right"
                 class="clickable">
              <i class="fas fa-plus-circle" style="font-size: 18px; margin-right: 11px; line-height: 42px"></i>
            </div>
          </div>
        <% }  %>
      <% }  %>
    </div>
  </div>

  <div class="list-group list-custom-small list-icon-0">
    <div class="no-effect collapsed" onclick="new bootstrap.Collapse( '#collapse-individual', { toggle: true } )" aria-expanded="false">
      <span class="font-14 text-uppercase text-black">Individuelle Gewohnheit</span>
      <i class="fa fa-angle-down"></i>
    </div>
  </div>
  <div class="collapse" id="collapse-individual">
    <form data-id="addIndividualRoutineForm">
      <div class="row" style="margin-bottom: 0">
      <div class="col-12" style="padding-left: 0; padding-right: 0;">
        <div class="input-style has-borders no-icon validate-field mb-2">
          <input type="text"
                 class="form-control validate-text font-weight-bolder"
                 id="addIndividualRoutineName"
                 name="addIndividualRoutineName"
                 placeholder="Weitere Gewohnheit"
                 style="border-bottom-width: 1px!important;"
                 required />
          <label for="addIndividualRoutineName">Weitere Gewohnheit</label>
        </div>
      </div>
      <div class="col-12" style="padding-left: 0; padding-right: 0;">
        <div class="input-style has-borders no-icon mb-2">
          <label for="addIndividualRoutineCategoryId" class="font-weight-bolder">Kategorie</label>
          <select id="addIndividualRoutineCategoryId"
                  name="addIndividualRoutineCategoryId"
                  data-id="addIndividualRoutineCategoryId" required>
            <option value="">Kategorie wählen...</option>
            <option value="daily-morning">Morgenroutine</option>
            <option value="daily-midday">Mittagsroutine</option>
            <option value="daily-evening">Abendroutine</option>
            <option value="daily-goal">Tagesziel</option>
            <option value="weekly-goal">Wochenziel</option>
          </select>
          <span><i class="fa fa-chevron-down"></i></span>
        </div>
      </div>
      <div class="col-6" style="padding-left: 0; padding-right: 0;">
        <div data-id="btnSelectIndividualIcon"
             class="input-style"
             data-icon-src="hearts-suit.svg"
             style="height: 53px;
                    border-width: 1px;
                    border-style: solid;
                    display: inline-block;
                    margin-left: 10px;
                    width: calc( 100% - 20px);
                    padding: 6px;
                    border-color: rgba(0, 0, 0, 0.08) !important;
                    padding-left: 13px !important;
                    padding-right: 10px !important;
                    border-radius: 10px !important;">
              <img src="/assets/icons/routines/hearts-suit.svg"
                   style="max-width: 26px; padding-top: 8px;padding-right: 4px"
                   data-id="individual-item" class="img-fluid">
          <em><i class="fa fa-chevron-down"></i></em>
        </div>
      </div>
      <div class="col-6" style="padding-left: 0; padding-right: 0;">
        <div class="input-style has-borders no-icon mb-2">
          <label for="addIndividualRoutineWeeklyFrequence"
                 class="color-highlight">Häufigkeit pro Woche</label>
          <select id="addIndividualRoutineWeeklyFrequence"
                  data-id="addIndividualRoutineWeeklyFrequence"
                  name="addIndividualRoutineWeeklyFrequence"
                  required
                  name="addIndividualRoutineWeeklyFrequence">
            <option>1</option>
            <option>2</option>
            <option>3</option>
            <option>4</option>
            <option>5</option>
            <option>6</option>
            <option selected="selected">7</option>
          </select>
          <span><i class="fa fa-chevron-down"></i></span>
        </div>
      </div>
    </div>
    </form>
    <div class="row mt-3">
      <div class="col">
        <button data-id="btnAddIndividual" style="width: 100%; " class="btn close-menu btn-full btn-m text-white bg-primary font-600 rounded-s">Hinzufügen</button>
      </div>
    </div>
  </div>

  <hr />

  <div class="row mt-3">
    <div class="col">
      <button data-id="btnCancel"
              style="width: 100%"
              class="btn close-menu btn-full btn-m color-red-dark border-red-dark font-600 rounded-s">Abbrechen</button>
    </div>
  </div>

</div>
